import React, { useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../redux/hook';
import HorairesFooter from '../HorairesFooter';
import { showHoursModal } from '../../redux/actions';
import { initializeMap, updateMap } from './MapSection.services';
import { getTheme } from '../../utils';
import Button from '../Button';
import { PRIMARY, WHITE } from '../../constants';

type MapSectionProps = {
	index?: number;
};

export default function MapSection({ index = 0 }: MapSectionProps) {
	const dispatch = useAppDispatch();
	const mapSectionRef = useRef<HTMLDivElement>(null);
	const mapInstanceRef = useRef<any>(null);

	const { shops, webapp } = useAppSelector((state) => ({
		shops: state.shopReducer.shops,
		webapp: state.configurationReducer.webapp,
	}));
	const { googleMapsEnabled } = useAppSelector(
		(state) => state.componentReducer
	);

	useEffect(() => {
		if (googleMapsEnabled && mapSectionRef.current) {
			initializeMap(mapSectionRef, mapInstanceRef);
			updateMap(shops, mapInstanceRef);
		}
	}, [googleMapsEnabled]);

	useEffect(() => {
		if (googleMapsEnabled && mapInstanceRef.current) {
			updateMap(shops, mapInstanceRef);
		}
	}, [googleMapsEnabled, shops]);

	const renderMultipleShops = () => {
		return Object.keys(shops).map((key) => {
			const shop = shops[key];
			const { address, hours, support } = shop;
			const { street, postalCode, city } = address;
			return (
				<React.Fragment key={key}>
					<div className="row w-100">
						<div className="col-8">
							<h5>{shop.name}</h5>
							<p className="text-muted">
								{street}, {postalCode}, {city}
								<br />
								{support?.number}
							</p>
						</div>
						<div className="col-4 my-auto">
							<Button
								type={PRIMARY}
								onClick={() => {
									dispatch(
										showHoursModal({
											show: true,
											hours,
										})
									);
								}}
							>
								Voir les horaires
							</Button>
						</div>
					</div>
					<hr className="hr-gray hr" />
				</React.Fragment>
			);
		});
	};

	const renderSingleShop = () => {
		const key = Object.keys(shops)[0];
		const shop = shops[key];
		const { address, hours, support = {} } = shop;
		const { street, postalCode, city } = address;

		return (
			<div className="text-center" key={key}>
				<div className="row mb-3">
					<div className="col">
						<h5>Adresse</h5>
						<p>
							{street}
							<br />
							{postalCode}, {city}
							<br />
							{support.number}
						</p>
					</div>
				</div>
				<div className="row mb-3">
					<div className="col">
						<h5>Nos Horaires</h5>
						<HorairesFooter hours={hours} />
					</div>
				</div>
			</div>
		);
	};

	const nbShops = Object.keys(shops).length;
	const { imageCoverUrl3 } = webapp?.images ?? {};
	const { style, textColor } = getTheme(index, imageCoverUrl3);

	return (
		<section className={textColor} style={style}>
			<div
				style={{
					backgroundColor: index % 2 ? 'rgba(0,0,0,.8)' : WHITE,
				}}
			>
				<div className="container">
					<div className="row py-5">
						<div className="col-lg-6 p-0 p-sm-4">
							{nbShops === 1 ? (
								<>
									<h1 className="mb-2 text-center text-title">
										Nous retrouver
									</h1>
									<h5 className="mb-4 text-muted text-center">
										Retrouvez votre magasin proche de chez vous
									</h5>
									{renderSingleShop()}
								</>
							) : nbShops > 1 ? (
								<>
									<h1 className="mb-2 text-center text-title">
										Nos Restaurants
									</h1>
									<h5
										className={`mb-4 text-center ${
											textColor === 'text-white'
												? textColor
												: 'text-muted'
										}`}
									>
										Retrouvez votre commerce proche de chez vous
									</h5>
									<div>{renderMultipleShops()}</div>
								</>
							) : null}
						</div>
						<div className="col-lg-6 p-0 p-sm-4">
							<div ref={mapSectionRef} style={{ height: '70vh' }} />
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
